import { view } from "@risingstack/react-easy-state";

import type { NutritionLine } from "../../common/types/productTypes";

const skip = (v: string) => {
   return !(v.startsWith("-") || v.length === 0);
};

type NutritionProps = {
   data: NutritionLine[];
};

const Nutrition = ({ data }: NutritionProps) => (
   <>
      {!!data && (
         <div className="tw-mb-6">
            {data.map((r, i) => (
               <div
                  key={r.name + (i + 1)}
                  className="tw-mb-2 tw-pb-2 tw-flex tw-justify-between tw-border-0 tw-border-b tw-border-ink-border-subtle tw-border-solid"
               >
                  <div className={`${r.name.startsWith("-") ? "tw-pl-3" : ""}`}>{r.name}</div>
                  <div className="tw-text-end">{r.value}</div>
               </div>
            ))}
         </div>
      )}
   </>
);

export default view(Nutrition);
